import { TreatmentScanType } from 'app/core/enums';

export const PatientSmileScanTypes: ReadonlySet<TreatmentScanType> = new Set<TreatmentScanType>([
  TreatmentScanType.PatientPhoto,
  TreatmentScanType.FrontSmile,
  TreatmentScanType.SmileDesignFrontSmile,
  TreatmentScanType.VeneersDesignFrontSmile,
]);
